
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timeline/all_books",
      function () {
        return require("private-next-pages/timeline/all_books.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timeline/all_books"])
      });
    }
  